import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class MineDamageLabelView extends View {
    /**
     * @param {string} parentId
     */
    constructor(parentId) {
        super(parentId, null);

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // Operator
        ////////////////////////////////////

        const labelElement = Page.createElement('div', parentElement, null, 'mine-damage-panel-operator-section');
        
        const labelTopRow = Page.createElement('div', labelElement, null, 'mine-damage-panel-section-header');
        labelTopRow.innerHTML += 'Mine';

        const labelBottomRow = Page.createElement('div', labelElement, null, 'mine-damage-panel-section-body');
        labelBottomRow.innerHTML = 'Damage:';

        super.initializeView();        
    }

}